// eslint-disable-next-line import/prefer-default-export
export const LOGIN_TYPE = {
    FORM: 'form',
    IFRAME: 'iframe',
    WINDOW: 'window',
};

export const RECENT_BOOKMAKERS_MAP = {
    bet365: 'bet365',
    betfair: 'betfair',
    coral: 'coral',
    ladbrokes: 'ladbrokes',
    paddypower: 'paddypower',
    skybet: 'skybet',
    williamhill: 'williamhill',
};

export const BOOKMAKERS_QUIZ = [
    "sky_bet_quiz",
    "william_hill_quiz",
    "paddy_power_quiz",
    "betfair_quiz",
    "bet365_quiz",
    "ladbrokes_quiz",
    "coral_quiz",
    "tote_quiz",
]



// WEBPACK FOOTER //
// /src/js/common/bookmakersList/bookmakersList.constants.js